<div class="trivia">
  <div class="top">
    <p class="typography-title">
      {{ triviaRegular().question }}
    </p>
    <countdown
      #cd
      class="countdown"
      [config]="{ leftTime: triviaRegular().timeleft, format: 'mm:ss' }"
      (event)="countDownEvent($event)"
    />
  </div>
  <form
    [formGroup]="answerForm"
    (ngSubmit)="onSubmit()"
    #answerFormRef="ngForm"
  >
    <app-form-field
      [formControl]="answer"
      [errorType]="'outline'"
      [id]="'answer'"
      [placeholder]="'Enter your best guess... '"
      [error]="
        !answer.valid && answerFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <button
      class="button button--style-yellow h-32 padding-x-12"
      style="--button-height: var(--size-36)"
      type="submit"
      [disabled]="answerForm.disabled || !answerForm.valid"
    >
      Send
    </button>
  </form>
  <div class="extra">
    <app-cost [cost]="triviaRegular().amount" balanceType="skins" />
    <app-player-row
      (click)="contextMenuService.open($event, { user: user() })"
      [player]="user()"
    />
  </div>
</div>
